import { render, staticRenderFns } from "./ShipmentSelect.vue?vue&type=template&id=cd1e8248&"
import script from "./ShipmentSelect.vue?vue&type=script&lang=js&"
export * from "./ShipmentSelect.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports